import {
  Home,
  Users,
  UserPlus,
  Calendar,
  GraduationCap,
  UserCog,
  FileText,
  Bell,
  MessageSquare,
  BarChart3,
  Settings,
  Building,
  Dumbbell,
  PlusCircle,
  CreditCard,
  Megaphone,
  Mail,
  Share2,
  UserCircle,
  FolderUsers,
  Upload,
  FolderOpen,
  Image,
  Smartphone,
  AlertCircle,
  Clock,
  Activity,
  GitCompare,
  Kanban,
  Sparkles,
  Inbox
} from 'lucide-react';
import { ReactComponent as DashboardMenuIcon } from '../assets/icons/menu-dashboard.svg';
import { ReactComponent as ClientiMenuIcon } from '../assets/icons/menu-clienti.svg';
import { ReactComponent as ClientiListaIcon } from '../assets/icons/menu-clienti-lista.svg';
import { ReactComponent as ClientiAggiungiIcon } from '../assets/icons/menu-clienti-aggiungi.svg';
import { ReactComponent as ClientiImportaCsvIcon } from '../assets/icons/menu-clienti-importa-csv.svg';
import { ReactComponent as CalendarioIcon } from '../assets/icons/menu-calendario.svg';
import { ReactComponent as CorsiIcon } from '../assets/icons/menu-corsi.svg';
import { ReactComponent as CorsiListaIcon } from '../assets/icons/menu-corsi-lista.svg';
import { ReactComponent as CorsiIscrizioneIcon } from '../assets/icons/menu-corsi-iscrizione.svg';
import { ReactComponent as TemplateIcon } from '../assets/icons/menu-template.svg';
import { ReactComponent as TemplateGruppiIcon } from '../assets/icons/menu-template-gruppi.svg';
import { ReactComponent as NotificheIcon } from '../assets/icons/menu-notifiche.svg';
import { ReactComponent as ArchivioEserciziIcon } from '../assets/icons/menu-archivio-esercizi.svg';
import { ReactComponent as OrariIcon } from '../assets/icons/menu-orari.svg';
import { ReactComponent as StatistichePalestraIcon } from '../assets/icons/menu-statistiche-palestra.svg';
import { ReactComponent as StatisticheIndividualiIcon } from '../assets/icons/menu-statistiche-individuali.svg';
import { ReactComponent as ImpostazioniIcon } from '../assets/icons/menu-impostazioni.svg';
import { filterNavigationLinksByAllowedPaths } from '../utils/gymPlanAccess';

/**
 * Configurazione navigazione per ruoli utente
 * Ogni ruolo ha:
 * - mainLinks: Links principali nel menu
 * - secondaryLinks: Links secondari (Statistics, Settings)
 * - bottomLinks: Links in basso (sempre visibili)
 */

export const navigationConfig = {
  // 🏢 GYM - Palestra completa (9 main links → riorganizzati in menu espandibili)
  gym: {
    mainLinks: [
      {
        to: '/gym',
        icon: DashboardMenuIcon,
        label: 'gym.navigation.dashboard',
        exactMatch: true
      },
      {
        // Menu "Clienti" espandibile
        label: 'gym.navigation.clients',
        icon: ClientiMenuIcon,
        children: [
          {
            to: '/gym/members',
            icon: ClientiListaIcon,
            label: 'gym.navigation.members'
          },
          {
            to: '/gym/add-member',
            icon: ClientiAggiungiIcon,
            label: 'gym.navigation.addMember'
          },
          {
            to: '/gym/import-csv',
            icon: ClientiImportaCsvIcon,
            label: 'gym.navigation.importCsv'
          }
        ]
      },
      {
        to: '/gym/calendar',
        icon: CalendarioIcon,
        label: 'gym.navigation.calendar'
      },
      {
        // Menu "Corsi" espandibile
        label: 'gym.navigation.courses',
        icon: CorsiIcon,
        children: [
          {
            to: '/gym/courses',
            icon: CorsiListaIcon,
            label: 'gym.navigation.coursesList'
          },
          {
            to: '/gym/bulk-enrollment',
            icon: CorsiIscrizioneIcon,
            label: 'gym.navigation.bulkEnrollment'
          }
        ]
      },
      {
        // Menu "Template" espandibile
        label: 'gym.navigation.template',
        icon: TemplateIcon,
        children: [
          {
            to: '/gym/templates',
            icon: TemplateIcon,
            label: 'gym.navigation.template'
          },
          {
            to: '/gym/template-groups',
            icon: TemplateGruppiIcon,
            label: 'gym.navigation.templateGroups'
          }
        ]
      },
      {
        to: '/gym/exercises',
        icon: ArchivioEserciziIcon,
        label: 'gym.navigation.exercises'
      },
      {
        to: '/gym/opening-hours',
        icon: OrariIcon,
        label: 'gym.navigation.openingHours'
      },
      {
        to: '/gym/notifications',
        icon: NotificheIcon,
        label: 'gym.navigation.notifications'
      }
    ],
    secondaryLinks: [
      {
        to: '/gym/statistics',
        icon: StatistichePalestraIcon,
        label: 'gym.navigation.statisticsGym',
        exactMatch: true
      },
      {
        to: '/gym/statistics-individual',
        icon: StatisticheIndividualiIcon,
        label: 'gym.navigation.statisticsIndividual'
      },
      {
        label: 'gym.navigation.socialMarketing',
        icon: Megaphone,
        ownerOnly: true,
        children: [
          {
            to: '/gym/social',
            icon: Share2,
            label: 'gym.navigation.social'
          },
          {
            to: '/gym/email',
            icon: Mail,
            label: 'gym.navigation.email'
          }
        ]
      },
      {
        to: '/gym/contabilita',
        icon: CreditCard,
        label: 'gym.navigation.accounting',
        ownerOnly: true
      },
      {
        to: '/gym/settings',
        icon: ImpostazioniIcon,
        label: 'gym.navigation.settings'
      }
    ]
  },

  // 👨‍🏫 TRAINER - Meno links di Gym (6 main links → riorganizzati in menu espandibili)
  trainer: {
    mainLinks: [
      {
        to: '/gym',
        icon: DashboardMenuIcon,
        label: 'gym.navigation.dashboard',
        exactMatch: true
      },
      {
        // Menu "Clienti" identico a Gym
        label: 'gym.navigation.clients',
        icon: ClientiMenuIcon,
        children: [
          {
            to: '/gym/members',
            icon: ClientiListaIcon,
            label: 'gym.navigation.members'
          }
        ]
      },
      {
        to: '/gym/calendar',
        icon: CalendarioIcon,
        label: 'gym.navigation.calendar'
      },
      {
        // Accesso lista corsi
        label: 'gym.navigation.courses',
        icon: CorsiIcon,
        children: [
          {
            to: '/gym/courses',
            icon: CorsiListaIcon,
            label: 'gym.navigation.coursesList'
          }
        ]
      },
      {
        // Menu "Template" espandibile
        label: 'gym.navigation.template',
        icon: TemplateIcon,
        children: [
          {
            to: '/gym/templates',
            icon: TemplateIcon,
            label: 'gym.navigation.template'
          },
          {
            to: '/gym/template-groups',
            icon: TemplateGruppiIcon,
            label: 'gym.navigation.templateGroups'
          }
        ]
      },
      {
        to: '/gym/notifications',
        icon: NotificheIcon,
        label: 'gym.navigation.notifications'
      }
    ],
    secondaryLinks: [
      {
        to: '/gym/statistics',
        icon: StatistichePalestraIcon,
        label: 'gym.navigation.statisticsGym',
        exactMatch: true
      },
      {
        to: '/gym/statistics-individual',
        icon: StatisticheIndividualiIcon,
        label: 'gym.navigation.statisticsIndividual'
      }
    ]
  },

  // 👑 ADMIN - Pannello amministratore (navigazione chiara: Dashboard, Palestre, Utenti, Standalone, Richieste, resto)
  admin: {
    mainLinks: [
      {
        to: '/admin',
        icon: Home,
        label: 'admin.navigation.dashboard',
        exactMatch: true
      },
      {
        label: 'admin.navigation.gymManagement',
        icon: Building,
        children: [
          {
            to: '/admin/gyms/new',
            icon: PlusCircle,
            label: 'admin.navigation.gymCreate'
          },
          {
            to: '/admin/gyms',
            icon: Building,
            label: 'admin.navigation.gymList',
            exactMatch: true
          },
          {
            to: '/admin/gym-requests',
            icon: Inbox,
            label: 'admin.navigation.gymRequests',
            adminOnly: true
          },
          {
            to: '/admin/saas-plans',
            icon: CreditCard,
            label: 'admin.navigation.saasPlans',
            adminOnly: true
          }
        ]
      },
      {
        to: '/admin/planning',
        icon: Kanban,
        label: 'admin.navigation.planning',
        adminOnly: true
      },
      {
        label: 'admin.navigation.monitoring',
        icon: BarChart3,
        adminOnly: true,
        children: [
          {
            to: '/admin/gym-monitor',
            icon: BarChart3,
            label: 'admin.navigation.gymMonitor'
          },
          {
            to: '/admin/standalone',
            icon: UserCircle,
            label: 'admin.navigation.standaloneMonitor'
          }
        ]
      },
      {
        to: '/admin/users',
        icon: FileText,
        label: 'admin.navigation.usersAndWorkouts'
      },
      {
        to: '/admin/trial-templates',
        icon: Sparkles,
        label: 'admin.navigation.trialTemplates',
        adminOnly: true
      },
      {
        label: 'admin.navigation.advancedTools',
        icon: Settings,
        adminOnly: true,
        children: [
          {
            to: '/admin/exercise-images',
            icon: Image,
            label: 'admin.navigation.exerciseImages',
            exactMatch: true
          },
          {
            to: '/admin/exercise-images-errors',
            icon: AlertCircle,
            label: 'admin.navigation.exerciseImagesErrors'
          },
          {
            to: '/admin/tester-sync',
            icon: GitCompare,
            label: 'admin.navigation.testerSync'
          },
          {
            to: '/admin/open-workouts',
            icon: Activity,
            label: 'admin.navigation.openWorkouts'
          }
        ]
      },
      {
        to: '/admin/exercises',
        icon: Dumbbell,
        label: 'admin.navigation.exercises',
        adminOnly: true
      },
      {
        to: '/admin/app-versions',
        icon: Smartphone,
        label: 'admin.navigation.appVersions',
        adminOnly: true
      },
      {
        to: '/admin/feedback',
        icon: MessageSquare,
        label: 'admin.navigation.feedback'
      },
      {
        to: '/admin/notifications',
        icon: Bell,
        label: 'admin.navigation.notifications'
      }
    ],
    secondaryLinks: []
  },

  // 🏠 STANDALONE - Utente indipendente (4 main links)
  standalone: {
    mainLinks: [
      {
        to: '/standalone/dashboard',
        icon: Home,
        label: 'navigation.home',
        exactMatch: true
      },
      {
        to: '/standalone/crea-scheda',
        icon: PlusCircle,
        label: 'navigation.createWorkout'
      },
      {
        to: '/standalone/visualizza-schede',
        icon: FileText,
        label: 'navigation.workouts'
      },
      {
        to: '/ai-training',
        icon: BarChart3,
        label: 'navigation.aiTraining'
      }
    ],
    secondaryLinks: [
      {
        to: '/standalone/settings',
        icon: Settings,
        label: 'navigation.settings'
      }
    ]
  }
};

/** Solo gestore palestra (non trainer) */
const filterOwnerOnlyLinks = (links, isGymRole) => {
  if (isGymRole) return links;
  return links.filter((link) => !link.ownerOnly);
};

/**
 * Ottiene i links di navigazione in base al ruolo utente
 * @param {Object} currentUser - Utente corrente
 * @param {Function} isGym - Funzione per verificare se è Gym
 * @param {Function} isTrainer - Funzione per verificare se è Trainer
 * @param {Function} isAdmin - Funzione per verificare se è Admin
 * @returns {Object} - { mainLinks, secondaryLinks }
 */
export const getNavigationLinks = (currentUser, isGym, isTrainer, isAdmin, options = {}) => {
  const allowedPaths = options.allowedPaths ?? null;

  if (isAdmin()) {
    const adminLinks = navigationConfig.admin;
    return {
      mainLinks: adminLinks.mainLinks,
      secondaryLinks: adminLinks.secondaryLinks
    };
  }

  if (isGym()) {
    const gym = navigationConfig.gym;
    return {
      mainLinks: filterNavigationLinksByAllowedPaths(gym.mainLinks, allowedPaths),
      secondaryLinks: filterNavigationLinksByAllowedPaths(
        filterOwnerOnlyLinks(gym.secondaryLinks, true),
        allowedPaths,
      ),
    };
  }

  if (isTrainer()) {
    const trainer = navigationConfig.trainer;
    return {
      mainLinks: filterNavigationLinksByAllowedPaths(trainer.mainLinks, allowedPaths),
      secondaryLinks: filterNavigationLinksByAllowedPaths(
        filterOwnerOnlyLinks(trainer.secondaryLinks, false),
        allowedPaths,
      ),
    };
  }

  if (currentUser?.role_name === 'standalone') {
    return navigationConfig.standalone;
  }

  return navigationConfig.standalone;
};

/**
 * Appiattisce i link di navigazione (figli dei menu espandibili) per accesso rapido in dashboard.
 * Esclude la home dashboard e rispetta adminOnly.
 *
 * @returns {Array<{ to: string, icon: *, label: string, exactMatch?: boolean, groupLabel?: string }>}
 */
export const flattenNavigationQuickLinks = (links, { isAdmin, excludeTo = ['/admin'] } = {}) => {
  const excludeSet = new Set(excludeTo);
  const out = [];
  const seen = new Set();

  const push = (item, groupLabel) => {
    if (!item?.to || excludeSet.has(item.to)) return;
    if (item.adminOnly && !isAdmin) return;
    if (seen.has(item.to)) return;
    seen.add(item.to);
    out.push({
      to: item.to,
      icon: item.icon,
      label: item.label,
      exactMatch: item.exactMatch,
      groupLabel: groupLabel || null
    });
  };

  for (const link of links || []) {
    if (link.children?.length) {
      for (const child of link.children) {
        push(child, link.label);
      }
    } else {
      push(link, null);
    }
  }

  return out;
};

/** Voci admin usate più spesso: in evidenza in cima alla dashboard. */
export const ADMIN_DASHBOARD_FEATURED_PATHS = ['/admin/planning', '/admin/open-workouts'];

